var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalorie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "47px",
    viewBox: "0 0 38 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Workout-1.3",
    transform: "translate(-45.000000, -456.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(45.000000, 456.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fire"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9974315,47 C8.52225911,47 0,38.7065078 0,28.5124505 C0,20.5843104 3.71141467,13.5150231 9.16062244,7.70922979 C13.6424039,2.93413322 18.0780408,0.304699825 18.2646044,0.195185998 C19.247822,-0.382217159 20.5673836,0.404483168 20.5673836,1.46841045 L20.5673836,14.1331842 L27.2417837,8.0856893 C27.8211426,7.56070224 28.7383585,7.59705385 29.2694926,8.18005663 C31.8062091,10.9638008 33.8255024,13.9034163 35.2712048,16.9173873 C43.3345723,33.7276219 32.2191454,47 18.9974315,47 Z",
    id: "Path",
    fill: "#F22B5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2668482,16.9169413 C33.818833,13.9028979 31.7963094,10.963212 29.2555348,8.17940104 C28.723551,7.59629248 27.8048678,7.5600318 27.2245821,8.08503146 L20.5395046,14.1326713 L20.5395046,1.4675939 C20.5395046,0.666554034 19.7904464,0.0229498015 19,0 L19,47 C32.2283746,46.97806 43.3363906,33.7136255 35.2668482,16.9169413 Z",
    id: "Path",
    fill: "#E52353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0000467,47 C15.071239,47 11.875,43.5832277 11.875,39.3835652 C11.875,32.5972905 18.0535866,28.5790453 18.3165648,28.4112618 C18.7775698,28.1173919 19.3547592,28.1311251 19.8030725,28.4460923 C20.061198,28.6276089 26.125,32.964802 26.125,39.3835652 C26.125,43.5832277 22.9288543,47 19.0000467,47 Z",
    id: "Path",
    fill: "#FFBA30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.125,39.3838201 C26.125,32.9646163 20.0333791,28.6269587 19.7741671,28.4454268 C19.5396108,28.2813115 19.2699929,28.1998013 19,28.2 L19,47 C22.9316778,46.9811899 26.125,43.5721916 26.125,39.3838201 Z",
    id: "Path",
    fill: "#FEB020"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalorie);
export default __webpack_public_path__ + "static/media/calorie.6d06951dd4d40782fa582d660ef925b4.svg";
export { ForwardRef as ReactComponent };